<template>
	<div class="leave-dashboard">
		<loading :active.sync="loading" :can-cancel="false" :is-full-page="true" :height="120" :width="120"
			:color="'#4F6BFF'" :background-color="'#0F172A'" :opacity="0.6"></loading>

		<v-container fluid class="pa-6">

			<!-- Page Header -->
			<div class="page-header mb-6">
				<div class="d-flex align-center">
					<div class="header-icon mr-3">
						<v-icon color="white" size="22">mdi-calendar-account</v-icon>
					</div>
					<div>
						<h1 class="page-title">{{ this.pageTitle }}</h1>
						<p class="page-subtitle">Track team availability at a glance</p>
					</div>
				</div>
			</div>

			<!-- Filter -->
			<app-parameter class="mb-5" v-bind:parentObject="{
				filter: this.showFilter,
			}" @input="onFilterInput($event)" />

			<v-row>
				<!-- Calendar Column -->
				<v-col cols="12" md="8">
					<div class="calendar-card">
						<calendar-view :show-date="this.showDate" class="theme-modern" @click-date="onClickDate"
							:events="calendaritems">
							<template #header="{ headerProps }">
								<calendar-view-header :header-props="headerProps" @input="setShowDate" />
							</template>
						</calendar-view>
					</div>
				</v-col>

				<!-- Sidebar Column -->
				<v-col cols="12" md="4">
					<div class="sidebar-stack">

						<!-- Today Card -->
						<div class="day-card today-card mb-4">
							<div class="day-card-header">
								<div class="day-label">
									<v-icon size="14" class="mr-1"
										color="rgba(255,255,255,0.85)">mdi-white-balance-sunny</v-icon>
									{{ $t('dayname.today') }}
								</div>
								<div class="day-date">{{ todaydate }}</div>
								<div class="attendance-badge" v-if="totalStaffPresentToday">
									{{ totalStaffPresentToday }}% present
								</div>
							</div>
							<div class="day-card-body">
								<div v-if="todayStaffListLeave.length === 0" class="empty-state">
									<v-icon size="16" color="#94a3b8">mdi-check-circle-outline</v-icon>
									<span>No leaves today</span>
								</div>
								<div v-for="item in todayStaffListLeave" :key="item.listid" class="leave-item">
									<span class="status-badge"
										:class="item.lvlstatusholder == '(A)' ? 'status-approved' : 'status-pending'">
										{{ item.lvlstatusholder }}
									</span>
									<span class="leave-code">{{ item.leavecode }}</span>
									<span class="leave-name">{{ item.psnname }}</span>
								</div>
							</div>
						</div>

						<!-- Tomorrow Card -->
						<div class="day-card tomorrow-card">
							<div class="day-card-header">
								<div class="day-label">
									<v-icon size="14" class="mr-1"
										color="rgba(255,255,255,0.85)">mdi-weather-sunset</v-icon>
									{{ $t('dayname.tomorrow') }}
								</div>
								<div class="day-date">{{ tomorrowdate }}</div>
								<div class="attendance-badge" v-if="totalStaffPresentTomorrow">
									{{ totalStaffPresentTomorrow }}% present
								</div>
							</div>
							<div class="day-card-body">
								<div v-if="tomorrowStaffListLeave.length === 0" class="empty-state">
									<v-icon size="16" color="#94a3b8">mdi-check-circle-outline</v-icon>
									<span>No leaves tomorrow</span>
								</div>
								<div v-for="item in tomorrowStaffListLeave" :key="item.listid" class="leave-item">
									<span class="status-badge"
										:class="item.lvlstatusholder == '(A)' ? 'status-approved' : 'status-pending'">
										{{ item.lvlstatusholder }}
									</span>
									<span class="leave-code">{{ item.leavecode }}</span>
									<span class="leave-name">{{ item.psnname }}</span>
								</div>
							</div>
						</div>

					</div>
				</v-col>
			</v-row>

			<!-- Selected Date Panel -->
			<v-row v-if="loaddate">
				<v-col>
					<div class="selected-date-panel mt-2">
						<div class="panel-header">
							<div class="d-flex align-center">
								<v-icon color="#4F6BFF" class="mr-2" size="18">mdi-calendar-today</v-icon>
								<span class="panel-title">{{ loaddate }}</span>
							</div>
							<span class="leave-count-badge">{{ loadStaffListLeave.length }} on leave</span>
						</div>
						<div class="panel-body">
							<div v-if="loadStaffListLeave.length === 0" class="empty-state">
								<v-icon size="16" color="#94a3b8">mdi-calendar-check</v-icon>
								<span>No leaves on this date</span>
							</div>
							<div v-for="item in loadStaffListLeave" :key="item.listid" class="leave-row"
								@click="goTo(item)">
								<div class="leave-row-left">
									<span class="status-badge"
										:class="item.lvlstatusholder == '(A)' ? 'status-approved' : 'status-pending'">
										{{ item.lvlstatusholder }}
									</span>
									<span class="leave-code">{{ item.leavecode }}</span>
								</div>
								<span class="leave-name">{{ item.psnname }}</span>
								<v-icon size="16" color="#94a3b8">mdi-chevron-right</v-icon>
							</div>
						</div>
					</div>
				</v-col>
			</v-row>

		</v-container>
	</div>
</template>

<style>
.leave-dashboard {
	background: #F0F4FF;
	min-height: 100vh;
	font-family: 'DM Sans', 'Segoe UI', sans-serif;
}

.page-header {
	display: flex;
	align-items: center;
}

.header-icon {
	background: linear-gradient(135deg, #4F6BFF, #7C3AFF);
	border-radius: 12px;
	width: 44px;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 4px 12px rgba(79, 107, 255, 0.35);
}

.page-title {
	font-size: 1.5rem;
	font-weight: 700;
	color: #1E293B;
	margin: 0;
	line-height: 1.2;
}

.page-subtitle {
	font-size: 0.8rem;
	color: #64748B;
	margin: 0;
}

.calendar-card {
	background: #ffffff;
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
	border: 1px solid #E8EDF5;
}

.theme-modern.cv-wrapper {
	font-family: 'DM Sans', 'Segoe UI', sans-serif !important;
	border: none !important;
}

.theme-modern .cv-header {
	background: linear-gradient(135deg, #4F6BFF 0%, #7C3AFF 100%) !important;
	border: none !important;
	padding: 14px 16px !important;
}

.theme-modern .cv-header button,
.theme-modern .cv-header .periodLabel {
	color: #ffffff !important;
	font-weight: 600 !important;
	border: none !important;
	background: rgba(255, 255, 255, 0.15) !important;
	border-radius: 8px !important;
	padding: 4px 10px !important;
}

.theme-modern .cv-header button:hover {
	background: rgba(255, 255, 255, 0.28) !important;
}

.theme-modern .cv-header .periodLabel {
	background: transparent !important;
	font-size: 1.05rem !important;
}

.theme-modern .cv-weekdays {
	background: #F8FAFF !important;
	border-bottom: 1px solid #E8EDF5 !important;
}

.theme-modern .cv-weekday {
	font-size: 0.72rem !important;
	font-weight: 600 !important;
	color: #64748B !important;
	text-transform: uppercase !important;
	letter-spacing: 0.06em !important;
	padding: 8px 0 !important;
	border: none !important;
}

.theme-modern .cv-weeks {
	border: none !important;
}

.theme-modern .cv-week {
	border-bottom: 1px solid #F1F5F9 !important;
	min-height: 80px !important;
}

.theme-modern .cv-day {
	border-right: 1px solid #F1F5F9 !important;
	border-bottom: none !important;
	background: #fff !important;
	transition: background 0.15s !important;
}

.theme-modern .cv-day:hover {
	background: #F5F7FF !important;
	cursor: pointer;
}

.theme-modern .cv-day.today {
	background: #EEF2FF !important;
}

.theme-modern .cv-day.today .cv-day-number {
	background: #4F6BFF !important;
	color: #fff !important;
	border-radius: 50% !important;
	width: 26px !important;
	height: 26px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	font-weight: 700 !important;
}

.theme-modern .cv-day-number {
	font-size: 0.82rem !important;
	color: #475569 !important;
	font-weight: 500 !important;
	padding: 6px 8px !important;
}

.theme-modern .cv-day.outsideOfMonth .cv-day-number {
	color: #CBD5E1 !important;
}

.theme-modern .cv-event {
	background: linear-gradient(135deg, #4F6BFF, #7C3AFF) !important;
	color: #fff !important;
	border: none !important;
	border-radius: 6px !important;
	font-size: 0.72rem !important;
	font-weight: 600 !important;
	padding: 2px 6px !important;
	margin: 1px 3px !important;
	box-shadow: 0 2px 6px rgba(79, 107, 255, 0.3) !important;
	text-overflow: ellipsis !important;
	white-space: nowrap !important;
	overflow: hidden !important;
}

.day-card {
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	border: 1px solid #E8EDF5;
	overflow: hidden;
}

.today-card .day-card-header {
	background: linear-gradient(135deg, #4F6BFF, #7C3AFF);
}

.tomorrow-card .day-card-header {
	background: linear-gradient(135deg, #0F9B6E, #06B6D4);
}

.day-card-header {
	padding: 14px 16px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
}

.day-label {
	font-size: 0.78rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: rgba(255, 255, 255, 0.85);
	display: flex;
	align-items: center;
}

.day-date {
	font-size: 0.9rem;
	font-weight: 600;
	color: #fff;
	margin-left: auto;
}

.attendance-badge {
	background: rgba(255, 255, 255, 0.2);
	color: #fff;
	font-size: 0.72rem;
	font-weight: 600;
	border-radius: 20px;
	padding: 2px 10px;
	width: 100%;
}

.day-card-body {
	padding: 12px 14px;
	max-height: 220px;
	overflow-y: auto;
}

.leave-item {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 0;
	border-bottom: 1px solid #F1F5F9;
}

.leave-item:last-child {
	border-bottom: none;
}

.status-badge {
	font-size: 0.68rem;
	font-weight: 700;
	border-radius: 5px;
	padding: 2px 6px;
	flex-shrink: 0;
}

.status-approved {
	background: #D1FAE5;
	color: #065F46;
}

.status-pending {
	background: #FEE2E2;
	color: #991B1B;
}

.leave-code {
	font-size: 0.78rem;
	font-weight: 600;
	color: #334155;
	flex-shrink: 0;
}

.leave-name {
	font-size: 0.78rem;
	color: #64748B;
	flex: 1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.empty-state {
	display: flex;
	align-items: center;
	gap: 6px;
	color: #94a3b8;
	font-size: 0.82rem;
	padding: 8px 0;
}

.selected-date-panel {
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
	border: 1px solid #E8EDF5;
	overflow: hidden;
}

.panel-header {
	background: #F8FAFF;
	border-bottom: 1px solid #E8EDF5;
	padding: 14px 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.panel-title {
	font-weight: 700;
	color: #1E293B;
	font-size: 0.95rem;
}

.leave-count-badge {
	background: #EEF2FF;
	color: #4F6BFF;
	font-size: 0.75rem;
	font-weight: 700;
	border-radius: 20px;
	padding: 3px 12px;
}

.panel-body {
	padding: 12px 16px;
}

.leave-row {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 12px;
	border-radius: 10px;
	cursor: pointer;
	transition: background 0.15s;
	border-bottom: 1px solid #F1F5F9;
}

.leave-row:last-child {
	border-bottom: none;
}

.leave-row:hover {
	background: #F5F7FF;
}

.leave-row-left {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
}

.day-card-body::-webkit-scrollbar {
	width: 4px;
}

.day-card-body::-webkit-scrollbar-track {
	background: #F1F5F9;
}

.day-card-body::-webkit-scrollbar-thumb {
	background: #CBD5E1;
	border-radius: 4px;
}
</style>

<script>
import moment from "moment";
import FilterParameter from '../../../components/common/FilterParameter';
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import "vue-simple-calendar/static/css/default.css";
import "vue-simple-calendar/static/css/holidays-us.css";
import Loading from "vue-loading-overlay";

export default {
	components: {
		'app-parameter': FilterParameter,
		CalendarView,
		CalendarViewHeader,
		Loading,
	},

	data() {
		return {
			showDate: new Date(),
			rules: {
				required: (value) => !!value || this.$t('reportsparam.required'),
				email: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(value) || this.$t('reportsparam.invalidemail');
				},
			},
			pageTitle: this.$t('whoisonleave'),
			todaydate: null,
			tomorrowdate: null,
			loaddate: null,
			startMonthDate: moment(new Date()).startOf('month').format("YYYY-MM-DD"),
			endMonthDate: moment(new Date()).endOf('month').format("YYYY-MM-DD"),

			showFilter: {
				staffid: true,
				gradeid: true,
				employmenttypeid: true,
				companyid: true,
				branchid: true,
				departmentid: true
			},
			parameters: {
				staffid: null,
				gradeid: null,
				emptypeid: null,
				compnyid: null,
				brchid: null,
				deptid: null
			},

			calendaritems: [],
			leaverecordList: [],
			todayStaffListLeave: [],
			todayStaffListHolder: [],
			tomorrowStaffListLeave: [],
			loadStaffListLeave: [],
			totalStaff: [],
			totalStaffPresentToday: [],
			totalStaffPresentTomorrow: [],
			totalStaffMov: [],
			loadDateRecord: [],
			loading: false,
		};
	},

	watch: {

		// startMonthDate() {
		// 	const vm = this;
		// 	let id = 0;

		// 	this.todayStaffListLeave = [];
		// 	this.tomorrowStaffListLeave = [];
		// 	this.loadStaffListLeave = [];
		// 	this.calendaritems = [];
		// 	this.loadDateRecord = [];

		// 	this.$store.dispatch('get', { url: `/leaverecordwho/all/${this.$store.getters.userId}/${vm.startMonthDate}/${vm.endMonthDate}` })
		// 		.then(async (res) => {
		// 			let dataitems = res.data.rec

		// 			for (let i = 0; i < dataitems.length; i++) {
		// 				let leaved = await this.checkDate(dataitems[i])
		// 				dataitems[i].tleave = leaved.hday
		// 				id++
		// 			}

		// 			if (id == dataitems.length) {
		// 				dataitems.map(val => {
		// 					let it2 = this.totalStaffMov.filter(val2 => {
		// 						return val2.staffid == val.staffid && val2.recdate <= val.startdate && val2.recenddate >= val.enddate
		// 					})[0]
		// 					val.emptypeid = it2.emptypeid
		// 					val.brchid = it2.brchid
		// 					val.compnyid = it2.compnyid
		// 					val.deptid = it2.deptid
		// 					val.gradeid = it2.grdid
		// 					return val
		// 				})

		// 				let dateh = []
		// 				for (let i = 0; i < dataitems.length; i++) {
		// 					let getd = [...new Set(dataitems[i].tleave.map(item => item))]
		// 					dateh = dateh.concat(getd)
		// 				}
		// 				let fdate = [...new Set(dateh.map(x => x))]
		// 				let g = 0
		// 				for (let i = 0; i < fdate.length; i++) {
		// 					let dt = dataitems.filter(x => {
		// 						let hol = x.tleave.indexOf(fdate[i])
		// 						if (hol == -1) { return false }
		// 						return x
		// 					})
		// 					let newdt = [...dt]
		// 					for (let j = 0; j < newdt.length; j++) {
		// 						let itm = { ...newdt[j], cdate: fdate[i], listid: g++ }
		// 						vm.leaverecordList.push(itm)
		// 					}
		// 					vm.calendaritems.push({
		// 						id: i + 1,
		// 						startDate: fdate[i],
		// 						title: newdt.length
		// 					})
		// 				}
		// 				this.loadRecordToday(vm.leaverecordList);
		// 				this.loadRecordTomorrow(vm.leaverecordList);
		// 			}
		// 		})
		// 		.catch((err) => {
		// 			vm.isErrTrigger = true;
		// 			vm.errMsg = err;
		// 		});
		// },// v0, using checkdate 

		async startMonthDate() {
			// const vm = this;

			// 1. Reset state variables
			this.todayStaffListLeave = [];
			this.tomorrowStaffListLeave = [];
			this.loadStaffListLeave = [];
			this.calendaritems = [];
			this.loadDateRecord = [];
			this.leaverecordList = []; // Ensure this is cleared too

			try {
				this.loading = true;
				// 2. Fetch data using await
				const url = `/leaverecordwho/all/${this.$store.getters.userId}/${this.startMonthDate}/${this.endMonthDate}`;
				const res = await this.$store.dispatch('get', { url });
				let dataitems = res.data.rec || [];

				// 3. Process data: Generate dates and link Staff Movement info
				dataitems = dataitems.map(val => {
					// Generate dates locally using moment (Replacing checkDate)
					const start = moment(val.startdate);
					const end = moment(val.enddate);
					const localLeaveDays = [];
					let current = start.clone();

					while (current.isSameOrBefore(end)) {
						localLeaveDays.push(current.format('YYYY-MM-DD'));
						current.add(1, 'days');
					}
					val.tleave = localLeaveDays;

					// Link staff movement details
					const mov = this.totalStaffMov.find(m =>
						m.staffid == val.staffid &&
						m.recdate <= val.startdate &&
						m.recenddate >= val.enddate
					);

					if (mov) {
						val.emptypeid = mov.emptypeid;
						val.brchid = mov.brchid;
						val.compnyid = mov.compnyid;
						val.deptid = mov.deptid;
						val.gradeid = mov.grdid;
					}
					return val;
				});

				// 4. Flatten all dates to find unique workdays
				const allDates = dataitems.flatMap(item => item.tleave);
				const uniqueDates = [...new Set(allDates)];

				// 5. Populate Calendar and Leave Record List
				let listIdCounter = 0;
				uniqueDates.forEach((currentDate, index) => {
					const staffOnLeave = dataitems.filter(x => x.tleave.includes(currentDate));

					staffOnLeave.forEach(person => {
						this.leaverecordList.push({
							...person,
							cdate: currentDate,
							listid: listIdCounter++
						});
					});

					this.calendaritems.push({
						id: index + 1,
						startDate: currentDate,
						title: String(staffOnLeave.length)
					});
				});

				// 6. Final UI updates
				await this.loadRecordToday(this.leaverecordList);
				await this.loadRecordTomorrow(this.leaverecordList);
				await this.checkFilter(); // Ensure filter is applied after data load

			} catch (err) {
				console.error("Error in startMonthDate:", err);
				this.isErrTrigger = true;
				this.errMsg = err;
			} finally {
				this.loading = false;
			}
		}, // v1, using async await and local date generation
	},

	methods: {

		// async checkDate(item) {
		// 	const vm = this
		// 	const dataholder = {
		// 		staffid: item.staffid,
		// 		leavetypeid: item.leavetypeid,
		// 		startdate: moment(item.startdate).format('YYYY-MM-DD'),
		// 		enddate: moment(item.enddate).format('YYYY-MM-DD'),
		// 		userid: vm.$store.getters.userId
		// 	}
		// 	let leavedays = this.$store.dispatch('post', { url: "/leave/leaveday", payload: dataholder })
		// 		.then(res => {
		// 			let item = res.data.rec
		// 			item.hday = item.normalday.filter(val => {
		// 				return val >= dataholder.startdate && val <= dataholder.enddate
		// 			})
		// 			return item
		// 		})
		// 		.catch(err => {
		// 			this.isErr = true;
		// 			this.errMsg = err;
		// 		});
		// 	return leavedays
		// }, // not one called , so comment out

		// loadRecordCountList() {
		//   const vm = this;
		//   let id = 0

		//   this.$store.dispatch('get', {url: `/leaverecordwho/all/${this.$store.getters.userId}/${vm.startMonthDate}/${vm.endMonthDate}`})
		//     .then(async (res) => {
		//       let dataitems = res.data.rec;

		//       for (let i = 0; i < dataitems.length; i++) {
		//         let leaved = await this.checkDate(dataitems[i])
		//         dataitems[i].tleave = leaved.hday
		//         id++
		//       }

		//       if (id == dataitems.length) {
		//         dataitems.map(val => {
		//           let it2 = this.totalStaffMov.filter(val2 => {
		//             return val2.staffid == val.staffid && val2.recdate <= val.startdate && val2.recenddate >= val.enddate
		//           })[0]
		//           val.emptypeid = it2.emptypeid
		//           val.brchid = it2.brchid
		//           val.compnyid = it2.compnyid
		//           val.deptid = it2.deptid
		//           val.gradeid = it2.grdid
		//           return val
		//         })

		//         let dateh = []
		//         for (let i = 0; i < dataitems.length; i++) {
		//           let getd = [...new Set(dataitems[i].tleave.map(item => item))]
		//           dateh = dateh.concat(getd)
		//         }
		//         let fdate = [...new Set(dateh.map(x => x))]
		//         let g = 0
		//         for (let i = 0; i < fdate.length; i++) {
		//           let dt = dataitems.filter(x => {
		//             let hol = x.tleave.indexOf(fdate[i])
		//             if (hol == -1) { return false }
		//             return x
		//           })
		//           let newdt = [...dt]
		//           for (let j = 0; j < newdt.length; j++) {
		//             let itm = {...newdt[j], cdate: fdate[i], listid: g++}
		//             vm.leaverecordList.push(itm)
		//           }
		//           vm.calendaritems.push({
		//             id: i+1,
		//             startDate: fdate[i],
		//             title: newdt.length
		//           })
		//         }
		//         this.loadRecordToday(vm.leaverecordList);
		//         this.loadRecordTomorrow(vm.leaverecordList);
		//       }
		//     })
		//     .catch((err) => {
		//       vm.isErrTrigger = true;
		//       vm.errMsg = err;
		//     });
		// },// v0, using checkdate

		async loadRecordCountList() {
			this.loading = true;
			this.leaverecordList = [];
			this.calendaritems = [];

			try {
				// Fetch the leave records
				const url = `/leaverecordwho/all/${this.$store.getters.userId}/${this.startMonthDate}/${this.endMonthDate}`;
				const res = await this.$store.dispatch('get', { url });
				let dataitems = res.data.rec || [];

				// Step 1: Replace checkDate with local moment.js logic
				// Also attach staff movement data (Dept, Branch, etc.)
				dataitems = dataitems.map(val => {
					// --- Generate tleave dates locally ---
					const start = moment(val.startdate);
					const end = moment(val.enddate);
					const localLeaveDays = [];
					let current = start.clone();

					while (current.isSameOrBefore(end)) {
						localLeaveDays.push(current.format('YYYY-MM-DD'));
						current.add(1, 'days');
					}
					val.tleave = localLeaveDays;

					// --- Attach Staff Movement Info (Dept, Branch, etc.) ---
					const staffMov = this.totalStaffMov.find(v2 =>
						v2.staffid == val.staffid &&
						v2.recdate <= val.startdate &&
						v2.recenddate >= val.enddate
					);

					if (staffMov) {
						val.emptypeid = staffMov.emptypeid;
						val.brchid = staffMov.brchid;
						val.compnyid = staffMov.compnyid;
						val.deptid = staffMov.deptid;
						val.gradeid = staffMov.grdid;
					}
					return val;
				});

				// Step 2: Collect all unique dates
				let allDates = [];
				dataitems.forEach(item => {
					allDates = allDates.concat(item.tleave);
				});
				const uniqueDates = [...new Set(allDates)];

				// Step 3: Build the UI lists
				let listIdCounter = 0;
				const builtLeaverecordList = [];
				const builtCalendarItems = [];

				uniqueDates.forEach((currentDate, index) => {
					// Find everyone on leave on this specific day
					const staffOnLeave = dataitems.filter(x => x.tleave.includes(currentDate));

					staffOnLeave.forEach(person => {
						builtLeaverecordList.push({
							...person,
							cdate: currentDate,
							listid: listIdCounter++
						});
					});

					builtCalendarItems.push({
						id: index + 1,
						startDate: currentDate,
						title: String(staffOnLeave.length)
					});
				});

				// Step 4: Assign to component state
				this.leaverecordList = builtLeaverecordList;
				this.calendaritems = builtCalendarItems;

				// Step 5: Update stats
				await this.loadRecordToday(this.leaverecordList);
				await this.loadRecordTomorrow(this.leaverecordList);

			} catch (err) {
				this.isErrTrigger = true;
				this.errMsg = err;
				console.error('loadRecordCountList error:', err);
			} finally {
				this.loading = false;
			}
		}, //v1, direcyly using moment to push in

		loadRecordToday(data) {
			this.todaydate = moment().format('DD-MM-YYYY');
			let todayholder = moment().format('YYYY-MM-DD');
			let dataholder = data.filter(x => { return x.cdate == todayholder })
			for (let i = 0; i < dataholder.length; i++) {
				if (dataholder[i].lvstatusid == 1) dataholder[i].lvlstatusholder = '(P)'
				if (dataholder[i].lvstatusid == 2) dataholder[i].lvlstatusholder = '(A)'
				if (dataholder[i].lvstatusid == 3) dataholder[i].lvlstatusholder = '(R)'
				if (dataholder[i].lvstatusid == 4) dataholder[i].lvlstatusholder = '(C)'
			}
			let dataNotDuplicate = this.removeDuplicateKeys(dataholder);
			this.todayStaffListLeave = dataNotDuplicate
			this.todayStaffListHolder = dataNotDuplicate
			this.totalStaffPresentToday = this.countStaffPresent(dataNotDuplicate.length)
		},

		loadRecordTomorrow(data) {
			this.tomorrowdate = moment().add(1, 'days').format('DD-MM-YYYY');
			let tomorrowholder = moment().add(1, 'days').format('YYYY-MM-DD');
			let dataholder = data.filter(x => { return x.cdate == tomorrowholder })
			for (let i = 0; i < dataholder.length; i++) {
				if (dataholder[i].lvstatusid == 1) dataholder[i].lvlstatusholder = '(P)'
				if (dataholder[i].lvstatusid == 2) dataholder[i].lvlstatusholder = '(A)'
				if (dataholder[i].lvstatusid == 3) dataholder[i].lvlstatusholder = '(R)'
				if (dataholder[i].lvstatusid == 4) dataholder[i].lvlstatusholder = '(C)'
			}
			let dataNotDuplicate = this.removeDuplicateKeys(dataholder);
			this.tomorrowStaffListLeave = dataNotDuplicate
			this.totalStaffPresentTomorrow = this.countStaffPresent(dataNotDuplicate.length)
		},

		loadRecordList(date) {
			let dataholder = [];
			let getdatadefault = this.leaverecordList.filter(x => { return x.cdate == date })
			let getdatafilter = this.loadDateRecord.filter(x => { return x.cdate == date })
			this.loadDateRecord.length > 0 ? dataholder = getdatafilter : dataholder = getdatadefault
			for (let i = 0; i < dataholder.length; i++) {
				if (dataholder[i].lvstatusid == 1) dataholder[i].lvlstatusholder = '(P)'
				if (dataholder[i].lvstatusid == 2) dataholder[i].lvlstatusholder = '(A)'
				if (dataholder[i].lvstatusid == 3) dataholder[i].lvlstatusholder = '(R)'
				if (dataholder[i].lvstatusid == 4) dataholder[i].lvlstatusholder = '(C)'
			}
			let data = this.removeDuplicateKeys(dataholder);
			this.loadStaffListLeave = data;
		},

		removeDuplicateKeys(arr) {
			const ids = arr.map(o => o.listid)
			const filtered = arr.filter(({ listid }, index) => !ids.includes(listid, index + 1))
			return filtered;
		},

		// loadTotalStaff() {
		//   const vm = this;
		//   this.loading = true;
		//   return this.$store.dispatch('get', {url: "/staff/alls"})
		//     .then((res) => {
		//       this.totalStaff = res.data.rec
		//       this.loadStaffMov();
		//       this.loading = false;
		//     })
		//     .catch((err) => {
		//       vm.isErrTrigger = true;
		//       vm.errMsg = err;
		//       this.loading = false;
		//     });
		// },// v0, not await

		async loadTotalStaff() {
			const vm = this;
			this.loading = true;

			try {
				// Wait for the staff data to return
				const res = await this.$store.dispatch('get', { url: "/staff/alls" });

				this.totalStaff = res.data.rec;

				// Trigger the next load
				await this.loadStaffMov();

			} catch (err) {
				// Catch any network or store errors
				vm.isErrTrigger = true;
				vm.errMsg = err;
				console.error("Error loading total staff:", err);
			} finally {
				// // Ensure loading is set to false regardless of success or failure
				// this.loading = false; // now we have the loadrecord() to control the loading
			}
		},

		loadStaffMov() {
			const vm = this;
			this.$store.dispatch('get', { url: `/staffmov/all/${this.$store.getters.userId}` })
				.then((res) => {
					this.totalStaffMov = res.data.rec
					this.loadRecordCountList();
				})
				.catch((err) => {
					vm.isErrTrigger = true;
					vm.errMsg = err;
				});
		},

		countStaffPresent(val) {
			const staffholder = this.totalStaff.length
			let item = ((staffholder - val) / staffholder) * 100
			return item.toFixed(2)
		},

		setShowDate(d) {
			this.showDate = d;
			this.startMonthDate = moment(this.showDate).startOf('month').format("YYYY-MM-DD");
			this.endMonthDate = moment(this.showDate).endOf('month').format("YYYY-MM-DD");
		},

		onClickDate(d) {
			this.loaddate = moment(d).format("DD-MM-YYYY")
			this.loadRecordList(moment(d).format("YYYY-MM-DD"));
		},

		goTo(item) {
			this.$router.push({ name: 'whoisonleavedetail', params: { item } });
		},

		onFilterInput(event) {
			this.parameters = {
				staffid: event.staffid,
				gradeid: event.gradeid,
				emptypeid: event.employmenttypeid,
				compnyid: event.companyid,
				brchid: event.branchid,
				deptid: event.departmentid
			}
			this.checkFilter()
		},

		async checkFilter() {
			const vm = this
			vm.calendaritems = []
			const query = this.filterParam(vm.parameters);
			const result1 = this.filerData(vm.leaverecordList, query);
			let data = this.removeDuplicateKeys(result1);
			const dateh = [...new Set(data.map(item => item.cdate))]
			for (let i = 0; i < dateh.length; i++) {
				let tdate = data.filter(x => x.cdate == dateh[i])
				vm.calendaritems.push({
					id: i + 1,
					startDate: dateh[i],
					title: tdate.length
				})
			}
			await this.loadRecordToday(data)
			await this.loadRecordTomorrow(data)
			this.loadDateRecord = data
			this.loadStaffListLeave = []
			this.loaddate = null
		},

		filterParam(filter) {
			let query = {};
			for (const key in filter) {
				if (filter[key]) { query[key] = filter[key]; }
			}
			return query
		},

		filerData(data, query) {
			const filteredData = data.filter(item => {
				for (let key in query) {
					if (item[key] === undefined || query[key] != item[key]) { return false; }
				}
				return true;
			});
			return filteredData;
		}
	},

	async mounted() {
		await this.loadTotalStaff();
	},
};
</script>